import { useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axiosInstance from "../../../../../axios/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../actions/actions";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { encrypt } from "../../../../global/helperFunctions";
import PenaltySelectEditor from "./PenaltyEditor";
import FormControl from "@mui/material/FormControl";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Tooltip from "@mui/material/Tooltip";
import { sailNumComparator } from "../../../../global/helperFunctions";
import StartTimeConfirmModal from "../../Finish-Time-Entry-New/StartTimeConfirmModal";

const sortOptions = [
  { label: "Default", value: "position" },
  { label: "Sail No", value: "sailNum" },
  { label: "Fleet", value: "fleetName" },
];

const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 31.5,
  height: 19.5,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 1.5,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(13px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#356DAD",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16.5,
    height: 16.5,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default function FinishTime(props) {
  const [raceSessionURL, setRaceSessionURL] = useState("");

  let unfinishedEntrants = useSelector(
    (state) =>
      state.initialFinishRaceEntrantsList.initialFinishRaceEntrantsList.data,
  );
  let aboutFinishRaceEntrants = useSelector(
    (state) =>
      state.aboutFinishRaceEntrantsList.aboutFinishRaceEntrantsList.data,
  );
  let completeFinishRaceEntrants = useSelector(
    (state) =>
      state.completeFinishRaceEntrantsList.completeFinishRaceEntrantsList.data,
  );

  const [snWithAlpha, setSNWithAlpha] = useState(true);
  const [onWaterEntrants, setOnWaterEntrants] = useState(false);
  const [retainDidNot, setRetainDidNot] = useState(false);
  const [retainHr, setRetainHr] = useState(false);
  const timePenalties = ["ARB", "ENP", "ESP", "SCP", "ZFP", "RDG", "OCS", "DNF", "RET", "DSQ", "BFD", "UFD"];
  const [timeZone, setTimeZone] = useState("");
  const [warnOneTime, setWarnOneTime] = useState(false);
  const [payload, setPayload] = useState([]);
  const [run, setRun] = useState(false);
  const gridRefs = [useRef(null), useRef(null), useRef(null)];
  const [gridApi, setGridApi] = useState(null);
  const [unfinishedSearchValue, setUnfinishedSearchValue] = useState("");
  const [selectedDidNot, setSelectedDidNot] = useState("");
  const [selectedHr, setSelectedHr] = useState("");
  const [sortField, setSortField] = useState("position");
  const [isSortAsc, setIsSortAsc] = useState(false);

  const sortFn = (a, b) => {
    const field = sortField || "";
    let aVal, bVal;

    if (field === "time") {
      aVal = (+a?.hr || 0) * 3600 + (+a?.min || 0) * 60 + (+a?.sec || 0);
      bVal = (+b?.hr || 0) * 3600 + (+b?.min || 0) * 60 + (+b?.sec || 0);
    } else if (field === "place" || field === "position") {
      aVal = +a?.[field] || 0;
      bVal = +b?.[field] || 0;
    } else if (field === "sailNum") {
      return sailNumComparator(a?.sailNum, b?.sailNum, isSortAsc);
    } else {
      aVal = (a?.[field] || "").toString().toLowerCase();
      bVal = (b?.[field] || "").toString().toLowerCase();
    }

    const result = aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    return isSortAsc ? result : -result;
  };

  const handleSort = () => [...completeFinishRaceEntrants].sort(sortFn);

  useEffect(() => {
    dispatch(actions.updateCompleteFinishRaceEntrants(handleSort()));
  }, [isSortAsc, sortField]);

  const systemLocale = navigator.language || "en-US"; // Fetch system locale

  //const handleSortChanged = (event) => {
  //  const colStates = event.api.getColumnState()
  //
  //  const sortedCols = colStates.filter(c => c.sort).map(c => c.colId)
  //  const isTimeSort = ['hr', 'min', 'sec'].some(col => sortedCols.includes(col))
  //
  //  if (isTimeSort) {
  //    const clickedCol = ['hr', 'min', 'sec'].find(col =>
  //      sortedCols.includes(col)
  //    )
  //
  //    const direction = getSortDirection(colStates, clickedCol)
  //
  //    event.api.applyColumnState({
  //      state: [
  //        { colId: 'hr', sort: direction, sortIndex: 0 },
  //        { colId: 'min', sort: direction, sortIndex: 1 },
  //        { colId: 'sec', sort: direction, sortIndex: 2 },
  //      ],
  //      defaultState: { sort: null },
  //    })
  //  }
  //}

  const getSortDirection = (colStates, colId) => {
    return colStates.find((c) => c.colId === colId)?.sort || "asc";
  };

  const gridContext = {
    retainHR: retainHr,
    retainDN: retainDidNot,
    snWithAlpha: snWithAlpha,
    onWaterEntrants: onWaterEntrants,
    unfinishedEntrants: unfinishedEntrants,
    aboutFinishRaceEntrants: aboutFinishRaceEntrants,
    completeFinishRaceEntrants: completeFinishRaceEntrants,
    sessionId: props.session,
    isPlace: props.place,
    selectedDidNot,
    setSelectedDidNot,
    selectedHr,
    setSelectedHr,
  };

  useEffect(() => {
    let time_zone = timeZone === "" ? "Australia/Canberra" : timeZone;

    if (!warnOneTime) {
      let timeZoneNotFound = false;
      time_zone = localStorage.getItem("time_zone");
      if (!time_zone) {
        time_zone = "Australia/Canberra";
        timeZoneNotFound = true;
      }
      setTimeZone(time_zone);
      if (timeZoneNotFound) {
        props.activateSnackbarTab("Time Zone has not been set", "error", true);
      }
      setWarnOneTime(true);
    }
  }, []);

  useEffect(() => {
    console.log("aboutFinishRaceEntrants1233....--", aboutFinishRaceEntrants);
    // console.log("completeFinishRaceEntrants....--", completeFinishRaceEntrants);
    if (aboutFinishRaceEntrants.length == 0) addRow();
    if (aboutFinishRaceEntrants.length >= 1) {
      if (
        aboutFinishRaceEntrants[aboutFinishRaceEntrants.length - 1].sailNum ===
          "" &&
        aboutFinishRaceEntrants[aboutFinishRaceEntrants.length - 1].boatName ===
          "" &&
        props.place == false
      ) {
        setTimeout(() => {
          if (gridRefs[1].current && gridRefs[1].current.api) {
            // console.log("THE REF", gridRefs[1]);

            gridRefs[1].current.api.startEditingCell({
              rowIndex:
                aboutFinishRaceEntrants.length > 0
                  ? aboutFinishRaceEntrants.length - 1
                  : 0, // Index of new row
              colKey: "sailNum", // Column to focus on
            });
          }
        }, 100);
      }
    }
    savePrefinished();
    // refreshAllGrids();
  }, [aboutFinishRaceEntrants]);

  const refreshAllGrids = () => {
    gridRefs.forEach((gridRef, index) => {
      if (gridRef.current && gridRef.current.api) {
        // console.log(`Refreshing Grid ${index + 1}`);
        gridRef.current.api.refreshCells({ force: true });
      } else {
        console.warn(`GridRef ${index + 1} is not ready`);
      }
    });
  };

  const saveRow = async (data, contxt = {}) => {
    unfinishedEntrants =
      Object.keys(contxt).length > 0
        ? contxt.unfinishedEntrants
        : unfinishedEntrants;
    aboutFinishRaceEntrants =
      Object.keys(contxt).length > 0
        ? contxt.aboutFinishRaceEntrants
        : aboutFinishRaceEntrants;
    completeFinishRaceEntrants =
      Object.keys(contxt).length > 0
        ? contxt.completeFinishRaceEntrants
        : completeFinishRaceEntrants;

    const UPDATE_FINISH_TIMES = `api/clubs/FinishTime`;
    console.log("the Payload", data);
    let response = "";
    try {
      if (!data?.sailNum) {
        throw Error("Please add Sail Number");
      }
      response = await axiosInstance.post(UPDATE_FINISH_TIMES, data);
      // Handle response
      if (response.data.success) {
        let finishedRow = completeFinishRaceEntrants.filter(
          (x) => x.sailNum === data.sailNum,
        );

        if (finishedRow) {
          const updatedCompleteFinishRaceEntrants =
            completeFinishRaceEntrants.map((entrant) =>
              entrant?.sailNum === data?.sailNum
                ? { ...entrant, editable: response?.data?.data?.editable }
                : entrant,
            );

          // Only dispatch if something was actually updated
          const hasUpdate = completeFinishRaceEntrants.some(
            (entrant) => entrant.sailNum === data.sailNum,
          );

          if (hasUpdate) {
            dispatch(
              actions.updateCompleteFinishRaceEntrants(
                updatedCompleteFinishRaceEntrants,
              ),
            );
          }
        }
      }
    } catch (error) {
      console.log("the data 123", data);
      console.log("the resp", error.response);
      console.log("Error updating finish times:", error);

      let finishedRow = completeFinishRaceEntrants.filter(
        (x) => x.sailNum === data.sailNum,
      );
      console.log("the error finishedRow", finishedRow);
      if (finishedRow) {
        let updatedCompleteFinishRaceEntrants = completeFinishRaceEntrants.map(
          (entrant) =>
            entrant.sailNum === data.sailNum
              ? { ...entrant, editable: true }
              : entrant,
        );
        console.log("the error row", updatedCompleteFinishRaceEntrants);
        dispatch(
          actions.updateCompleteFinishRaceEntrants(
            updatedCompleteFinishRaceEntrants,
          ),
        );
      }
      const msg =
        error.response?.data?.message || error.message || "Unknown error";
      props.activateSnackbarTab(msg, "error", true);
    } finally {
      setPayload([]);
    }
  };

  const savePrefinished = async () => {
    if (props.session != "" && props.session > 0) {
      let response = "";
      try {
        let prefinishData = {};
        prefinishData["finishTimeDTOs0"] = [];
        prefinishData["finishTimeDTOs1"] = aboutFinishRaceEntrants;
        prefinishData["finishTimeDTOs2"] = [];
        const encryptedSessionId = encodeURIComponent(
          encrypt(JSON.stringify(props.session)),
        );

        const UPDATE_FINISH_TIMES =
          "api/clubs/FinishTime/prefinish?raceSession=" + encryptedSessionId;
        response = await axiosInstance.post(UPDATE_FINISH_TIMES, prefinishData);
        console.log("The prefinished response", response);
      } catch (error) {
        console.log("The prefinished error", error);
      }
    }
  };

  const deleteRow = async (data) => {
    const UPDATE_FINISH_TIMES = `api/clubs/FinishTime/delete`;
    // console.log("the finishTimePayload", data);
    try {
      const response = await axiosInstance.post(UPDATE_FINISH_TIMES, data);
      /*  */
      // Handle response
      // console.log("Response:", response.data);
    } catch (error) {
      // Handle errors
      console.error("Error updating finish times:", error);
    } finally {
      setPayload([]);
    }
  };

  const filteredUnfinishedEntrants = useMemo(() => {
    if (!onWaterEntrants) return unfinishedEntrants;
    return unfinishedEntrants.filter((entrant) => entrant?.onWater === 1);
  }, [onWaterEntrants, unfinishedEntrants]);

  const handleOnWaterSwitchChange = (e) => {
    setOnWaterEntrants(e.target.checked);
  };

  useEffect(() => {
    setRaceSessionURL(
      "../../../raceday/race-session?eventId=" +
        props.event +
        "&sessDate=" +
        props.raceSessionsDate,
    );
  }, [props.event, props.raceSession]);

  useEffect(() => {
    // Reset sort to default when parent signals a change (e.g., after import)
    if (props.changeSort !== undefined) {
      setSortField("position");
      setIsSortAsc(false);
    }
  }, [props.changeSort]);

  const mapRowToPayloadElement = (obj) => {
    let targetObj = {};
    targetObj["raceSessionId"] = props.session;
    if (obj.status != undefined) {
      targetObj["sessionEntrantId"] = obj.sessionEntrantId;
    } else {
      targetObj["sessionEntrantId"] = obj.id;
    }
    targetObj["place"] = 0;
    targetObj["sailNum"] = obj.sailNum;
    targetObj["hr"] = "00";
    targetObj["mm"] = "00";
    targetObj["ss"] = "00";
    targetObj["date"] = new Date()
      .toLocaleString("en-GB", { timeZone: timeZone })
      .split(",")[0]
      .trim()
      .split("/")
      .reverse()
      .join("-");
    targetObj["dn"] = "DNC";
    targetObj["fleet"] = obj.fleetName;
    return targetObj;
  };

  const getFinishTimeCalculations = async () => {
    try {
      console.log("THE FINISHeD ---- ", completeFinishRaceEntrants);
      if (
        completeFinishRaceEntrants.some(
          (entrant) => entrant.editable === true || entrant.editable === 1,
        )
      ) {
        // Return error or show a message
        console.error("Error: Some entries are still editable.");
        props.activateSnackbarTab(
          "The highlighted finish times are invalid or missing. Please review and correct all finish times before processing results. Results cannot be processed until all times are valid.",
          "error",
          true,
        );
        return;
      }

      props.setRefetchRequest(true);
      props.setProcessFlag(true);
      let payloadFirst = unfinishedEntrants
        .concat(aboutFinishRaceEntrants)
        .filter((evt) => !evt.editable)
        .map(mapRowToPayloadElement);
      const CALCULATE_HANDICAP = "api/HC/CalculateHandicap/" + props.session;
      const response = await axiosInstance.post(
        CALCULATE_HANDICAP,
        payloadFirst,
      );
      // console.log("RES--", response);
      setPayload(response.data.data);
    } catch (error) {
      setPayload([]);
    }
    setRun(true);
  };

  const [showStartTimeModal, setShowStartTimeModal] = useState(false);

  const handleProcessResultsClick = () => {
    if (
      completeFinishRaceEntrants.some(
        (entrant) => entrant.editable === true || entrant.editable === 1
      )
    ) {
      console.error("Error: Some entries are still editable.");
      props.activateSnackbarTab(
        "The highlighted finish times are invalid or missing. Please review and correct all finish times before processing results. Results cannot be processed until all times are valid.",
        "error",
        true
      );
      return;
    }
    setShowStartTimeModal(true);
  };

  const handleStartTimeModalClose = () => {
    setShowStartTimeModal(false);
  };

  const handleUpdateStartTime = () => {
    setShowStartTimeModal(false);
    if (props.setActiveTab) {
      props.setActiveTab("start");
    }
  };

  const handleProceed = async () => {
    setShowStartTimeModal(false);
    await getFinishTimeCalculations();
  };

  useEffect(() => {
    if (run) {
      postPublishPayload("postPublishPayload RUN BY USEEFFECT");
      setRun(false);
    }
  }, [run]);

  const postPublishPayload = async (message, responsePayload) => {
    try {
      if (payload?.length !== 0 || responsePayload.length?.length !== 0) {
        const POST_PUBLISH_API = "api/HC/CalculateHandicap";
        const response = await axiosInstance.post(
          POST_PUBLISH_API,
          payload?.length > 0 ? payload : responsePayload?.data,
        );
        // console.log("RES2--", response);
        props.setProcessFlag(false);
        props.activateSnackbarTab(
          "Results Processed Successfully",
          "success",
          true,
        );
      } else {
        props.setProcessFlag(false);
        throw new Error("Error occured in publishing Results");
      }
    } catch (error) {
      console.log(error);
      props.setProcessFlag(false);
      props.activateSnackbarTab(error?.response?.data?.message, "error", true);
    }
  };

  const updateHr = (e) => {
    setRetainHr(e.target.checked);
    setSelectedHr(null);
  };

  const updateDidNot = (e) => {
    setRetainDidNot(e.target.checked);
    setSelectedDidNot(null);
  };

  const preloadAll = () => {
    // console.log("the pre hr --- preload All", retainHr);
    if (unfinishedEntrants.length > 0) {
      // console.log("THE preload", aboutFinishRaceEntrants);
      if (
        aboutFinishRaceEntrants.length === 1 &&
        aboutFinishRaceEntrants[0].boatName === ""
      ) {
        aboutFinishRaceEntrants.pop();
      }
      // let tempObj = aboutFinishRaceEntrants[aboutFinishRaceEntrants.length - 1];
      let tempObj =
        aboutFinishRaceEntrants.length > 0
          ? aboutFinishRaceEntrants[aboutFinishRaceEntrants.length - 1]
          : { hr: "00", dn: "" };
      // console.log("the retain hr --- preload All", retainHr);
      // console.log(retainHr,tempObj)
      let defaultHr =
        retainHr &&
        selectedHr &&
        (!retainDidNot ||
          !selectedDidNot ||
          timePenalties.includes(selectedDidNot))
          ? selectedHr
          : "00";
      let defaultDn = retainDidNot && selectedDidNot ? selectedDidNot : "";

      // console.log("The preload All", aboutFinishRaceEntrants);
      let finishEnt = unfinishedEntrants.map((row) => ({
        ...row,
        hr: defaultHr,
        dn: defaultDn,
        min: "00",
        sec: "00",
      }));
      let updatedAboutFinishRaceEntrants = [
        ...aboutFinishRaceEntrants,
        ...finishEnt,
      ];

      let updatedCompleteFinishRaceEntrants = [];

      dispatch(
        actions.updateAboutFinishRaceEntrants(updatedAboutFinishRaceEntrants),
      );
      dispatch(
        actions.updateInitialFinishRaceEntrants(
          updatedCompleteFinishRaceEntrants,
        ),
      );

      setTimeout(() => {
        if (gridApi) {
          gridApi.startEditingCell({
            rowIndex: 0, // First row
            colKey: "place", // Place column
          });
        }
      }, 200); // Give time for grid update
    }
  };

  useEffect(() => {
    refreshAllGrids();
  }, [retainDidNot, retainHr]);

  const dispatch = useDispatch();

  const getRowClass = (params) => {
    if (params.data.editable === true || params.data.editable === 1) {
      return "error-row";
    }
    return "";
  };

  const [aboutToFinishColumnDefs] = useState([
    {
      field: "sailNum",
      headerName: "SAIL NO",
      flex: 2,
      minWidth: 80,
      maxWidth: 150,
      singleClickEdit: true,
      editable: (params) => !params.data?.boatName && !params.data?.isAbandon,
      cellClassRules: {
        "highlight-cell": (params) =>
          params.data?.boatName !== null && params.data?.boatName !== "",
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        overflow: "hidden",
      },
      cellRenderer: (params) => {
        const isManualEntry =
          !params.data?.boatName || params.data?.boatName === "";
        return (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
              // padding: '0 12px',
              fontWeight: isManualEntry ? "700" : "normal",
            }}
            title={params?.value || ""}
          >
            {params.value || ""}
          </div>
        );
      },
      valueParser: (params) => params.newValue?.toUpperCase() || "",
      onCellValueChanged: (event) => {
        //debugger
        // Get current data references
        let {
          unfinishedEntrants,
          aboutFinishRaceEntrants,
          completeFinishRaceEntrants,
        } = event.context;

        // Handle valid sail number update
        const matchingUnfinished = unfinishedEntrants.filter((x) => {
          const sailNum = (x.sailNum || "").toLowerCase();
          const newValue = (event?.newValue || "").toLowerCase();

          if (event.context.snWithAlpha) {
            return sailNum === newValue;
          } else {
            return (
              sailNum.replace(/[A-Za-z]/g, "") ===
              newValue.replace(/[A-Za-z]/g, "")
            );
          }
        });
        if (matchingUnfinished.length > 0) {
          let updatedUnfinished;

          if (event.context.snWithAlpha) {
            updatedUnfinished = unfinishedEntrants.filter(
              (x) => x.sailNum?.toLowerCase() !== event.newValue.toLowerCase(),
            );
          } else {
            updatedUnfinished = unfinishedEntrants.filter(
              (x) =>
                x.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") !==
                event.newValue.toLowerCase(),
            );
          }
          let defaultHr = isDefaultHrAllowed(event.context)
            ? event.context.selectedHr
            : "00";
          let defaultDn =
            event.context.retainDN && event.context.selectedDidNot
              ? event.context.selectedDidNot
              : "";
          const updatedEntry = {
            ...matchingUnfinished[0],
            hr: defaultHr ? defaultHr : event.data.hr,
            min: event.data.min,
            sec: event.data.sec,
            position: event.data.position,
            place: event.data.place,
            dn: defaultDn ? defaultDn : event.data.dn,
          };

          let updatedAboutFinish;
          if (event.context.snWithAlpha) {
            updatedAboutFinish = aboutFinishRaceEntrants.map((x) =>
              x.sailNum?.toLowerCase() === event.newValue.toLowerCase()
                ? updatedEntry
                : x,
            );
          } else {
            updatedAboutFinish = aboutFinishRaceEntrants.map((x) =>
              x.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") ===
              event.newValue.toLowerCase()
                ? updatedEntry
                : x,
            );
          }

          aboutFinishRaceEntrants = [...updatedAboutFinish];
          dispatch(actions.updateInitialFinishRaceEntrants(updatedUnfinished));
          dispatch(actions.updateAboutFinishRaceEntrants(updatedAboutFinish));

          aboutFinishRaceEntrants = [...updatedAboutFinish];
          dispatch(actions.updateInitialFinishRaceEntrants(updatedUnfinished));
          dispatch(actions.updateAboutFinishRaceEntrants(updatedAboutFinish));

          const rowIndex = event.node.rowIndex; // row index in the grid
          setTimeout(() => {
            // ignore this event loop
            setTimeout(() => {
              // ignore next event loop caused by dispatch
              event.api.startEditingCell({
                rowIndex: rowIndex,
                colKey: "hr",
              });
            }, 100);
          }, 100);

          // you can also refresh this row in-place
          //event.api.refreshCells({ rowNodes: [rowNode], force: true })

          // Update local references
          unfinishedEntrants = [...updatedUnfinished];
          aboutFinishRaceEntrants = [...updatedAboutFinish];
        } else {
          dispatch(
            actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants),
          );
        }

        dispatch(
          actions.updateFinishRaceManager([
            ...(matchingUnfinished.length > 0 ? [matchingUnfinished[0]] : []),
            ...aboutFinishRaceEntrants,
            ...completeFinishRaceEntrants,
          ]),
        );
      },
    },
    {
      field: "boatName",
      headerName: props.caseOTBEntrant ? "Class" : "BOAT",
      flex: 2,
      minWidth: 100,
      maxWidth: 200,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        alignContent: "center",
      },
      cellRenderer: (params) => (
        <span title={params.value || ""}>{params.value}</span>
      ),
    },
    {
      field: "hr",
      headerName: "HR",
      editable: (params) => !params.data?.isAbandon,
      flex: 1,
      sortable: false,
      minWidth: 50,
      maxWidth: 80,
      singleClickEdit: true,
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;

        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          const numericValue = parseInt(newValue, 10);

          if (newValue === "" || (numericValue >= 0 && numericValue < 24)) {
            const finalValue =
              newValue === "" ? "" : String(numericValue).padStart(2, "0");
            params.data.hr = finalValue;
            params.data.errorHR = false;

            // Clear dn if it's not a time penalty
            params.data.dn =
              params.data.dn && !timePenalties.includes(params.data.dn)
                ? ""
                : params.data.dn;

            if (params.context?.retainHR && params.context?.setSelectedHr) {
              if (finalValue == "00") {
                params.context.setSelectedHr(null);
              } else {
                params.context.setSelectedHr(finalValue);
              }
            }

            // Auto-save
            params.data.oldSailNum = "";
            let data = makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            );
            saveRow(data, params.context);

            return true;
          }
        }

        params.data.errorHR = true;
        return false;
      },
      cellClassRules: {
        error: (params) => params.data.errorHR, // Apply 'error' class dynamically
      },
    },
    {
      field: "min",
      headerName: "MIN",
      sortable: false,

      editable: (params) => !params.data?.isAbandon,
      flex: 1,
      minWidth: 50,
      maxWidth: 80,
      singleClickEdit: true,
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;

        // Only allow numeric values and empty string
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          const numericValue = parseInt(newValue, 10);

          if (newValue === "" || (numericValue >= 0 && numericValue < 60)) {
            params.data.min =
              newValue === "" ? "" : String(numericValue).padStart(2, "0");
            params.data.errorMin = false;
            params.data.dn =
              params.data.dn && !timePenalties.includes(params.data.dn)
                ? ""
                : params.data.dn;

            params.data.oldSailNum = "";
            let data = makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            );
            saveRow(data, params.context);

            return true;
          }
        }

        params.data.errorMin = true;
        return false;
      },
      cellClassRules: {
        error: (params) => params.data.errorMin, // Apply 'error' class dynamically
      },
    },
    {
      field: "sec",
      headerName: "SEC",
      sortable: false,

      editable: (params) => !params.data?.isAbandon,
      flex: 1,
      minWidth: 50,
      maxWidth: 80,
      singleClickEdit: true,
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;

        // Only allow numeric values and empty string
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          const numericValue = parseInt(newValue, 10);

          if (newValue === "" || (numericValue >= 0 && numericValue < 60)) {
            params.data.sec =
              newValue === "" ? "" : String(numericValue).padStart(2, "0");
            params.data.errorSec = false;
            params.data.dn =
              params.data.dn && !timePenalties.includes(params.data.dn)
                ? ""
                : params.data.dn;

            // Auto-save logic
            params.data.oldSailNum = "";
            let data = makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            );
            saveRow(data, params.context);

            return true;
          }
        }

        params.data.errorSec = true;
        return false;
      },
      cellClassRules: {
        error: (params) => params.data.errorSec, // Apply 'error' class dynamically
      },
    },
    {
      field: "dn",
      headerName: "DN",
      flex: 2,
      minWidth: 90,
      maxWidth: 190,
      editable: (params) => !params.data?.isAbandon,
      singleClickEdit: true,
      cellEditor: PenaltySelectEditor,
      suppressKeyboardEvent: (params) => {
        return ["ArrowDown", "ArrowUp", "Enter"].includes(params.event.key);
      },
      cellEditorParams: { params: props.penalties },
      valueSetter: (params) => {
        const selectedValue = params.newValue;
        const { context } = params;

        // Save latest DN to state
        if (context.retainDN) {
          context.setSelectedDidNot(selectedValue);
        }

        aboutFinishRaceEntrants = params.context.aboutFinishRaceEntrants;
        params.data.dn = selectedValue;
        // Check if the selected value is part of the `timePenalties` array
        if (!timePenalties.includes(selectedValue) && params?.data?.dn != "") {
          // console.log("Selected Value:", selectedValue);
          // Update the `hr` field to "00" if selected value is part of timePenalties
          params.data.hr = "00";
          params.data.min = "00";
          params.data.sec = "00";
          params.data.errorHR = false;
          params.data.errorMin = false;
          params.data.errorSec = false;
        }
        if (
          selectedValue !== "" &&
          (selectedValue === "DNC" || !timePenalties.includes(selectedValue))
        ) {
          params.data.finishDate = "";
        }

        let aboutFinishRaceEntrants2 = [...aboutFinishRaceEntrants];
        dispatch(
          actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants2),
        );
        // Ensure the grid gets the correct value
        return true;
      },
    },
    {
      field: "capture",
      headerName: "Save",
      flex: 2,
      minWidth: 80,
      maxWidth: 180,
      cellRenderer: (params) => {
        const sailNum = params.data?.sailNum?.toLowerCase() || "";
        // closed this check on button instead validating in sailnum field for duplicates
        // Check if sailNum is a duplicate
        // const isDuplicate =
        //   sailNum &&
        //   (aboutFinishRaceEntrants.filter(
        //     (x) => x.sailNum.toLowerCase() === sailNum
        //   ).length >= 2 ||
        //     completeFinishRaceEntrants.filter(
        //       (x) => x.sailNum.toLowerCase() === sailNum
        //     ).length >= 1);
        return (
          <Button
            variant="contained"
            onClick={() =>
              handleNowAboutClick(params.data.sailNum, params.data, params)
            }
            value={params.value}
            color="primary"
            size="small"
            className="ty_primary_btn"
            // disabled={isDuplicate}
            disabled={params.data?.isAbandon}
          >
            NOW
          </Button>
        );
      },
    },
    {
      field: "remove",
      headerName: "DROP",
      flex: 2,
      minWidth: 70,
      maxWidth: 170,
      cellRenderer: (params) => (
        <Button
          onClick={() =>
            handleDelClick(params.data.sailNum, params.data, params)
          }
          value={params.value}
          color="primary"
          className="ty_cross_btn"
        >
          ×
        </Button>
      ),
    },
  ]);

  const [aboutToFinishPlaceColumnDefs] = useState([
    {
      field: "place",
      headerName: "PLC",
      editable: (params) => !params.data?.isAbandon,
      singleClickEdit: true,
      flex: 2,
      minWidth: 50,
      maxWidth: 80,
      // cellEditor: "agNumberCellEditor",
      valueFormatter: (params) => {
        const value = Number(params.value);
        return isNaN(value) || value === 0 ? "" : value;
      },
      valueSetter: (params) => {
        const val = params.newValue;
        // Allow blank
        if (val === "" || val === null) {
          params.data.place = "";
          return true;
        }
        // Allow only positive integers
        if (/^\d+$/.test(val)) {
          params.data.place = Number(val);
          return true;
        }
        // Reject invalid input, keep old value
        return false;
      },
      onCellValueChanged: (event) => {
        dispatch(
          actions.updateAboutFinishRaceEntrants(
            event.context.aboutFinishRaceEntrants,
          ),
        );
        savePrefinished();
      },
    },
    {
      field: "dn",
      headerName: "DN",
      flex: 2,
      minWidth: 80,
      maxWidth: 180,
      singleClickEdit: true,
      editable: (params) => !params.data?.isAbandon,
      cellEditor: PenaltySelectEditor,
      suppressKeyboardEvent: (params) => {
        return ["ArrowDown", "ArrowUp", "Enter"].includes(params.event.key);
      },
      cellEditorParams: { params: props.penalties },
      valueSetter: (params) => {
        const selectedValue = params.newValue;
        const { context } = params;
        // Save latest DN to state
        if (context.retainDN) {
          context.setSelectedDidNot(selectedValue);
        }

        aboutFinishRaceEntrants = params.context.aboutFinishRaceEntrants;
        params.data.dn = selectedValue;
        if (!timePenalties.includes(selectedValue) && params?.data?.dn != "") {
          params.data.hr = "00";
          params.data.min = "00";
          params.data.sec = "00";
        }

        let aboutFinishRaceEntrants2 = [...aboutFinishRaceEntrants];
        dispatch(
          actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants2),
        );
        savePrefinished();
        // Ensure the grid gets the correct value
        return true;
      },
    },
    {
      field: "boatName",
      headerName: props.caseOTBEntrant ? "Class" : "BOAT",
      flex: 2,
      minWidth: 150,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        alignItems: "center",
      },
      // maxWidth: 200,
      valueGetter: (params) => {
        const { boatName, sailNum } = params.data;
        return props.caseOTBEntrant
          ? `${sailNum || ""}(${boatName})`.trim()
          : boatName;
      },
      cellRenderer: (params) => (
        <span title={params.value || ""}>{params.value}</span>
      ),
    },
    {
      field: "capture",
      headerName: "Save",
      flex: 2,
      minWidth: 80,
      maxWidth: 130,
      cellRenderer: (params) => (
        <Button
          variant="contained"
          onClick={() =>
            handleNowAboutClick(params.data.sailNum, params.data, params)
          }
          value={params.value}
          color="primary"
          size="small"
          className="ty_primary_btn"
          disabled={params.data?.isAbandon}
        >
          SAVE
        </Button>
      ),
    },
    {
      field: "remove",
      headerName: "DROP",
      flex: 2,
      minWidth: 100,
      maxWidth: 200,
      cellRenderer: (params) => {
        return (
          <Button
            onClick={() =>
              handleDelClick(params.data.sailNum, params.data, params)
            }
            value={params.value}
            color="primary"
            className="ty_cross_btn"
          >
            ×
          </Button>
        );
      },
    },
  ]);

  const unfinishedColumnDefs = useMemo(
    () =>
      [
        props?.caseOTBEntrant && {
          field: "boatName",
          headerName: "CLASS",
          flex: 1,
          minWidth: 80,
          sortable: true,
          cellRenderer: (params) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
                title={params.value || ""}
              >
                {params.value}
              </span>
            </div>
          ),
        },
        !props?.caseOTBEntrant && {
          field: "boatName",
          headerName: "BOAT NAME",
          flex: 1,
          minWidth: 80,
          maxWidth: 300,
          cellRenderer: (params) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
                title={params.value || ""}
              >
                {params.value}
              </span>
            </div>
          ),
        },
        {
          field: "fleetName",
          headerName: "FLEET",
          sortable: true,
          flex: 1,
          minWidth: 80,
          cellRenderer: (params) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
                title={params.value || ""}
              >
                {params.value}
              </span>
            </div>
          ),
        },
        {
          field: "sailNum",
          headerName: "PRELOAD",
          sortable: true,
          flex: 1,
          minWidth: 80,
          comparator: sailNumComparator,
          cellRenderer: (params) => {
            const value = params.context.snWithAlpha
              ? params.value
              : params.value.replace(/[A-Za-z]/g, "");
            return (
              <Button
                className="ty_primary_btn ty_btn_finish_time_border"
                onClick={() => handleBoxClick(params)}
                title={value}
                size="small"
                style={{
                  width: "100%",
                  paddingLeft: 8,
                  paddingRight: 8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {value}
                </span>
              </Button>
            );
          },
          cellRendererParams: (params) => ({
            snWithAlpha, // Pass current state to the cellRenderer
          }),
        },
      ].filter(Boolean),
    [props?.caseOTBEntrant],
  );

  const [finishedPlaceColumnDefs] = useState([
    {
      field: "position",
      headerName: "POS",
      //sortable: false,
      //sort: "desc",
      hide: true,
      flex: 1,
      minWidth: 80,
      maxWidth: 100,
      comparator: (valueA, valueB) => {
        if (valueA === undefined || valueA === null || valueA === "") return 1;
        if (valueB === undefined || valueB === null || valueB === "") return -1;
        return Number(valueA) - Number(valueB);
      },
    },
    {
      field: "place",
      headerName: "PLC",
      editable: true,
      //sortable: true,
      //sort: "desc",
      flex: 2,
      minWidth: 100,
      maxWidth: 200,
      cellEditor: "agTextCellEditor",
      valueFormatter: (params) => {
        const value = params.value;
        if (
          value === null ||
          value === undefined ||
          value === "" ||
          isNaN(Number(value)) ||
          Number(value) === 0
        ) {
          return "";
        }
        return Number(value);
      },
      valueSetter: (params) => {
        const val = params.newValue;

        if ((val === "" || val === null) && params.data.dn === "") {
          params.data.place = params.oldValue;
        }

        // Allow blank
        if ((val === "" || val === null) && params.data.dn !== "") {
          params.data.place = "";
          return true;
        }
        // Allow only positive integers
        if (/^\d+$/.test(val)) {
          params.data.place = Number(val);
          return true;
        }
        // Reject invalid input, keep old value
        return false;
      },
    },
    {
      field: "sailNum",
      headerName: "SAILNUM",
      filter: "agTextColumnFilter", // Keeps filtering enabled
      floatingFilter: false, // Hides the small filter input below the header
      suppressMenu: true, // Hides the filter icon (three dots)
      flex: 2,
      minWidth: 100,
      maxWidth: 200,
      //sortable: true,
      cellClassRules: {
        error: (params) =>
          !params.value || params.value.trim() === "" || !params.data?.boatName,
        "highlight-cell": (params) =>
          params.data?.boatName !== null && params.data?.boatName !== "",
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        overflow: "hidden",
      },
      editable: (params) => !params.data?.boatName && !params.data?.isAbandon,
      cellRenderer: (params) => {
        const isManualEntry =
          !params.data?.boatName || params.data?.boatName === "";
        return (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
              // padding: '0 12px',
              fontWeight: isManualEntry ? "700" : "normal",
            }}
            title={params.value || ""}
          >
            {params.value || ""}
          </div>
        );
      },
      valueParser: (params) => params.newValue?.toUpperCase() || "",
      onCellValueChanged: (event) => {
        unfinishedEntrants = event.context.unfinishedEntrants;
        completeFinishRaceEntrants = event.context.completeFinishRaceEntrants;

        if (!event.newValue) {
          setTimeout(() => {
            props.activateSnackbarTab(
              "Please define sail number",
              "error",
              true,
            );
          }, 300);

          // Reset the incorrect edit
          event.data.sailNum = event.oldValue;

          const sailIndx = event.node.rowIndex;
          console.log("THE INDX", sailIndx);

          // Refocus the cell
          setTimeout(() => {
            const gridApi = gridRefs[2]?.current?.api;
            if (gridApi && sailIndx !== -1) {
              gridApi.ensureIndexVisible(sailIndx);

              gridApi.setFocusedCell(sailIndx, "sailNum");
              gridApi.startEditingCell({
                rowIndex: sailIndx,
                colKey: "sailNum",
              });
            }
          }, 100);

          return;
        }

        if (
          event.newValue &&
          (aboutFinishRaceEntrants.some(
            (x) => x.sailNum.toLowerCase() === event.newValue.toLowerCase(),
          ) ||
            completeFinishRaceEntrants.filter(
              (x) =>
                x.sailNum?.trim().toLowerCase() ===
                event.newValue.trim().toLowerCase(),
            ).length >= 2)
        ) {
          setTimeout(() => {
            props.activateSnackbarTab(
              `Sail Number ${event.newValue} already added!`,
              "error",
              true,
            );
          }, 300);
          event.data.sailNum = event.oldValue ? event.oldValue : "";
          const sailIndx = event.node.rowIndex;
          console.log("THE INDX", sailIndx);

          // Refocus the cell
          setTimeout(() => {
            const gridApi = gridRefs[2]?.current?.api;
            if (gridApi && sailIndx !== -1) {
              gridApi.ensureIndexVisible(sailIndx);

              gridApi.setFocusedCell(sailIndx, "sailNum");
              gridApi.startEditingCell({
                rowIndex: sailIndx,
                colKey: "sailNum",
              });
            }
          }, 100);

          return;
        }

        let oldRow = props.allUnfinished.filter(
          (x) => x?.sailNum?.toLowerCase() == event?.oldValue?.toLowerCase(),
        );
        // console.log("OLD---", oldRow);

        let unFinishRow = event.context.snWithAlpha
          ? unfinishedEntrants.filter(
              (x) =>
                x?.sailNum?.toLowerCase() === event?.newValue?.toLowerCase(),
            )
          : unfinishedEntrants.filter(
              (x) =>
                x?.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") ===
                event?.newValue?.toLowerCase(),
            );
        if (unFinishRow.length > 0) {
          console.log("-------unFinishRow--------", unFinishRow);
          console.log("OLD VALLL---", event.oldValue);
          let unfinishedEntrants2 = event.context.snWithAlpha
            ? unfinishedEntrants.filter(
                (x) =>
                  x?.sailNum?.toLowerCase() !== event?.newValue?.toLowerCase(),
              )
            : unfinishedEntrants.filter(
                (x) =>
                  x?.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") !==
                  event?.newValue?.toLowerCase(),
              );

          let completeFinishRaceEntrants2 = completeFinishRaceEntrants.filter(
            (x) => x?.sailNum?.toLowerCase() !== event?.newValue?.toLowerCase(),
          );

          // console.log(
          //   "THE completeFinishRaceEntrants2",
          //   completeFinishRaceEntrants2
          // );
          unFinishRow[0].hr = event.data.hr;
          unFinishRow[0].min = event.data.min;
          unFinishRow[0].sec = event.data.sec;
          unFinishRow[0].position = event.data.position;
          unFinishRow[0].place = event.data.place;
          unFinishRow[0].dn = event.data.dn;
          unFinishRow[0].oldSailNum = event.oldValue;
          unFinishRow[0].finishDate = props.overnight
            ? event.data.finishDate
              ? event.data.finishDate
              : new Date().toISOString().split("T")[0]
            : "";
          completeFinishRaceEntrants2.splice(
            event.node.rowIndex,
            0,
            unFinishRow[0],
          );

          // console.log("completeFinishRaceEntrants", completeFinishRaceEntrants);
          unfinishedEntrants = [...unfinishedEntrants2];
          dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants));
          // console.log(
          //   "completeFinishRaceEntrants2",
          //   completeFinishRaceEntrants2
          // );

          completeFinishRaceEntrants = [...completeFinishRaceEntrants2];
          dispatch(
            actions.updateCompleteFinishRaceEntrants(
              completeFinishRaceEntrants,
            ),
          );

          let finishedData = makePayloadForUpdate(
            unFinishRow[0],
            event.data.hr,
            event.data.min,
            event.data.sec,
            event.context.sessionId,
          );
          saveRow(finishedData, {
            ...event.context,
            completeFinishRaceEntrants,
          });
        } else {
          console.log("------- ELSE unFinishRow--------", unFinishRow);
          event.data.fleetName = "";
          event.data.boatName = "";
          event.data.id = "";
          event.data.editable = true;
          event.data.oldSailNum = event.oldValue;
          let finishedData = makePayloadForUpdate(
            event.data,
            event.data.hr,
            event.data.min,
            event.data.sec,
            event.context.sessionId,
          );
          saveRow(finishedData, event.context);
        }

        if (oldRow.length > 0) {
          unfinishedEntrants = [...unfinishedEntrants, ...oldRow];
          // console.log("INSIDE---", unfinishedEntrants);
          dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants));
        }

        dispatch(
          actions.updateFinishRaceManager([
            ...unFinishRow,
            ...aboutFinishRaceEntrants,
            ...completeFinishRaceEntrants,
          ]),
        );
      },
    },
    {
      field: "dn",
      headerName: "DN",
      suppressKeyboardEvent: (params) => {
        return ["ArrowDown", "ArrowUp", "Enter"].includes(params.event.key);
      },
      flex: 2,
      minWidth: 80,
      maxWidth: 180,
      editable: (params) => !params.data?.isAbandon,
      cellEditor: PenaltySelectEditor,
      cellEditorParams: { params: props.penalties },
      valueFormatter: (params) =>
        params.data?.isAbandon ? "ABN" : params.value,
      valueSetter: (params) => {
        // console.log("the DN Data", params);
        const selectedValue = params.newValue;
        params.data.dn = selectedValue;
        // Check if the selected value is part of the `timePenalties` array
        if (!timePenalties.includes(selectedValue) && params?.data?.dn != "") {
          // console.log("Selected Value:", selectedValue);
          // Update the `hr` field to "00" if selected value is part of timePenalties
          params.data.hr = "00";
          params.data.min = "00";
          params.data.sec = "00";
        }

        if (
          (isNaN(params?.data?.place) ||
            params?.data?.place === null ||
            params?.data?.place === "") &&
          (selectedValue === "" ||
            selectedValue === null ||
            selectedValue === undefined)
        ) {
          params.data.dn = params.oldValue;
        }

        let data = makePayloadForUpdate(
          params.data,
          params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
          params.data.min ? String(params.data.min).padStart(2, "0") : "00",
          params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
          params.context.sessionId,
        );
        saveRow(data, params.context);
        // Ensure the grid gets the correct value
        return true;
      },
    },

    {
      field: "fleetName",
      headerName: "FLEET",
      flex: 2,
      minWidth: 80,
      maxWidth: 100,
      cellRenderer: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
            title={params.value || ""}
          >
            {params.value}
          </span>
        </div>
      ),
    },
    {
      field: "del",
      headerName: "DROP",
      flex: 2,
      minWidth: 100,
      maxWidth: 200,
      cellRenderer: (params) => (
        <Button
          color="primary"
          className="ty_cross_btn"
          onClick={() =>
            handleCompletedDelClick(params.data.sailNum, params.data, params)
          }
          disabled={params.data?.isAbandon}
        >
          ×
        </Button>
      ),
    },
  ]);

  const [finishedColumnDefs] = useState([
    {
      field: "position",
      headerName: "POS",
      //sortable: true,
      //sort: "desc",
      hide: false,
      flex: 1,
      minWidth: 80,
      maxWidth: 100,
      comparator: (valueA, valueB) => {
        if (valueA === undefined || valueA === null || valueA === "") return 1;
        if (valueB === undefined || valueB === null || valueB === "") return -1;
        return Number(valueA) - Number(valueB);
      },
    },
    {
      field: "place",
      headerName: "PLC",
      //sortable: true,
      //sort: "desc",
      flex: 2,
      minWidth: 100,
      maxWidth: 150,
      hide: true,
      valueFormatter: (params) => {
        const value = Number(params.value);
        return isNaN(value) || value === 0 ? "" : value;
      },
    },
    {
      field: "sailNum",
      headerName: "SAIL NO",
      filter: "agTextColumnFilter", // Keeps filtering enabled
      floatingFilter: false, // Hides the small filter input below the header
      suppressMenu: true, // Hides the filter icon (three dots)
      flex: 2,
      minWidth: 80,
      maxWidth: 180,
      comparator: sailNumComparator,
      valueParser: (params) => params.newValue?.toUpperCase() || "",
      cellClassRules: {
        error: (params) =>
          !params.value || params.value.trim() === "" || !params.data?.boatName,
        "highlight-cell": (params) =>
          params.data?.boatName !== null && params.data?.boatName !== "",
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        overflow: "hidden",
      },
      cellRenderer: (params) => {
        const isManualEntry =
          !params.data?.boatName || params.data?.boatName === "";
        return (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
              // padding: '0 12px',
              fontWeight: isManualEntry ? "700" : "normal",
            }}
            title={params.value || ""}
          >
            {params.value || ""}
          </div>
        );
      },

      editable: (params) => !params.data?.boatName && !params.data?.isAbandon,

      onCellValueChanged: (event) => {
        // console.log("the event values", event);
        unfinishedEntrants = event.context.unfinishedEntrants;
        completeFinishRaceEntrants = event.context.completeFinishRaceEntrants;

        if (!event.newValue) {
          setTimeout(() => {
            props.activateSnackbarTab(
              "Please define sail number",
              "error",
              true,
            );
          }, 300);
          // Reset the incorrect edit
          event.data.sailNum = event.oldValue;

          const sailIndx = event.node.rowIndex;
          console.log("THE INDX", sailIndx);

          // Refocus the cell
          setTimeout(() => {
            const gridApi = gridRefs[2]?.current?.api;
            if (gridApi && sailIndx !== -1) {
              gridApi.ensureIndexVisible(sailIndx);

              gridApi.setFocusedCell(sailIndx, "sailNum");
              gridApi.startEditingCell({
                rowIndex: sailIndx,
                colKey: "sailNum",
              });
            }
          }, 100);

          return;
        }

        if (
          event.newValue &&
          (aboutFinishRaceEntrants.some(
            (x) => x.sailNum.toLowerCase() === event.newValue.toLowerCase(),
          ) ||
            completeFinishRaceEntrants.filter(
              (x) =>
                x.sailNum?.trim().toLowerCase() ===
                event.newValue.trim().toLowerCase(),
            ).length >= 2)
        ) {
          setTimeout(() => {
            props.activateSnackbarTab(
              `Sail Number ${event.newValue} already added!`,
              "error",
              true,
            );
          }, 300);
          event.data.sailNum = event.oldValue ? event.oldValue : "";
          const sailIndx = event.node.rowIndex;
          console.log("THE INDX", sailIndx);

          // Refocus the cell
          setTimeout(() => {
            const gridApi = gridRefs[2]?.current?.api;
            if (gridApi && sailIndx !== -1) {
              gridApi.ensureIndexVisible(sailIndx);

              gridApi.setFocusedCell(sailIndx, "sailNum");
              gridApi.startEditingCell({
                rowIndex: sailIndx,
                colKey: "sailNum",
              });
            }
          }, 100);

          return;
        }

        let tempObj =
          aboutFinishRaceEntrants[aboutFinishRaceEntrants.length - 1];
        let defaultHr = event.context.retainHR ? tempObj.hr : event.data.hr;
        let defaultDn = event.context.retainDN ? tempObj.dn : event.data.dn;
        let oldRow = props?.allUnfinished?.filter(
          (x) => x?.sailNum?.toLowerCase() == event?.oldValue?.toLowerCase(),
        );
        //console.log("unfinishedEntrants---", unfinishedEntrants);

        let unFinishRow = event.context.snWithAlpha
          ? unfinishedEntrants?.filter(
              (x) =>
                x?.sailNum?.toLowerCase() === event?.newValue?.toLowerCase(),
            )
          : unfinishedEntrants?.filter(
              (x) =>
                x?.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") ===
                event?.newValue?.toLowerCase(),
            );
        if (unFinishRow?.length > 0) {
          let unfinishedEntrants2 = event.context.snWithAlpha
            ? unfinishedEntrants?.filter(
                (x) =>
                  x?.sailNum?.toLowerCase() !== event?.newValue?.toLowerCase(),
              )
            : unfinishedEntrants?.filter(
                (x) =>
                  x?.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") !==
                  event?.newValue?.toLowerCase(),
              );

          let completeFinishRaceEntrants2 = completeFinishRaceEntrants?.filter(
            (x) => x?.sailNum?.toLowerCase() !== event?.newValue?.toLowerCase(),
          );

          // console.log(
          //   "THE completeFinishRaceEntrants2",
          //   completeFinishRaceEntrants2
          // );
          unFinishRow[0].hr = defaultHr == 0 ? "00" : defaultHr;
          unFinishRow[0].min = event.data.min == 0 ? "00" : event.data.min;
          unFinishRow[0].sec = event.data.sec == 0 ? "00" : event.data.sec;
          unFinishRow[0].position = event.data.position;
          unFinishRow[0].place = event.data.place;
          unFinishRow[0].dn = defaultDn;
          unFinishRow[0].oldSailNum = event.oldValue;
          unFinishRow[0].finishDate = props.overnight
            ? event.data.finishDate
              ? event.data.finishDate
              : new Date().toISOString().split("T")[0]
            : "";
          if (event.data.fleetName === "")
            event.data.sailNum = event.data.sailNum.toUpperCase();
          completeFinishRaceEntrants2.splice(
            event.node.rowIndex,
            0,
            unFinishRow[0],
          );

          // console.log("completeFinishRaceEntrants", completeFinishRaceEntrants);
          unfinishedEntrants = [...unfinishedEntrants2];
          dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants));
          // console.log(
          //   "completeFinishRaceEntrants2",
          //   completeFinishRaceEntrants2
          // );

          completeFinishRaceEntrants = [...completeFinishRaceEntrants2];
          dispatch(
            actions.updateCompleteFinishRaceEntrants(
              completeFinishRaceEntrants,
            ),
          );
          let finishedData = makePayloadForUpdate(
            unFinishRow[0],
            unFinishRow[0].hr,
            unFinishRow[0].min,
            unFinishRow[0].sec,
            event.context.sessionId,
          );
          saveRow(finishedData);
        } else {
          event.data.fleetName = "";
          event.data.boatName = "";
          event.data.id = "";
          event.data.hr = event.data.hr == 0 ? "00" : event.data.hr;
          event.data.min = event.data.min == 0 ? "00" : event.data.min;
          event.data.sec = event.data.sec == 0 ? "00" : event.data.sec;
          event.data.editable = true;
          event.data.oldSailNum = event.oldValue;

          let finishedRow = completeFinishRaceEntrants?.filter(
            (x) => x?.sailNum?.toLowerCase() === event?.newValue?.toLowerCase(),
          );
          // console.log("the finished", finishedRow)
          // console.log("the event data", event.data)
          if (finishedRow) {
            let updatedCompleteFinishRaceEntrants =
              completeFinishRaceEntrants?.map((entrant) =>
                entrant?.sailNum?.toLowerCase() ===
                event?.newValue?.toLowerCase()
                  ? event?.data
                  : entrant,
              );
            // console.log("the success row", updatedCompleteFinishRaceEntrants);
            dispatch(
              actions.updateCompleteFinishRaceEntrants(
                updatedCompleteFinishRaceEntrants,
              ),
            );
            let finishedData = makePayloadForUpdate(
              event.data,
              defaultHr,
              event.data.min,
              event.data.sec,
              event.context.sessionId,
            );
            saveRow(finishedData);
          }
        }

        if (oldRow.length > 0) {
          unfinishedEntrants = [...unfinishedEntrants, ...oldRow];
          // console.log("INSIDE---", unfinishedEntrants);
          dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants));
        }

        dispatch(
          actions.updateFinishRaceManager([
            ...unFinishRow,
            ...aboutFinishRaceEntrants,
            ...completeFinishRaceEntrants,
          ]),
        );
      },
    },
    {
      field: "hr",
      headerName: "HR",
      //sortable: true,
      flex: 1,
      minWidth: 40,
      maxWidth: 100,
      editable: (params) => !params.data?.isAbandon,
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;

        // Only allow numeric values and empty string
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          const numericValue = parseInt(newValue, 10);

          // Validate range (0-24)
          if (newValue === "" || (numericValue >= 0 && numericValue < 24)) {
            params.data.hr =
              newValue === "" ? "" : String(numericValue).padStart(2, "0");
            params.data.errorHR = false;
            params.data.dn =
              params.data.dn && !timePenalties.includes(params.data.dn)
                ? ""
                : params.data.dn;
            // Auto-save logic
            params.data.oldSailNum = "";
            let data = makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            );
            saveRow(data, params.context);

            return true;
          }
        }

        params.data.errorHR = true;
        return false;
      },
      cellClassRules: {
        error: (params) => params.data.errorHR, // Apply 'error' class dynamically
      },
    },
    {
      field: "min",
      headerName: "MIN",
      //sortable: true,
      flex: 1,
      minWidth: 50,
      maxWidth: 80,
      editable: (params) => !params.data?.isAbandon,
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;

        // Only allow numeric values and empty string
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          const numericValue = parseInt(newValue, 10);

          if (newValue === "" || (numericValue >= 0 && numericValue < 60)) {
            params.data.min =
              newValue === "" ? "" : String(numericValue).padStart(2, "0");
            params.data.errorMin = false;
            params.data.dn =
              params.data.dn && !timePenalties.includes(params.data.dn)
                ? ""
                : params.data.dn;

            params.data.oldSailNum = "";
            let data = makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            );
            saveRow(data, params.context);

            return true;
          }
        }

        params.data.errorMin = true;
        return false;
      },
      cellClassRules: {
        error: (params) => params.data.errorMin, // Apply 'error' class dynamically
      },
    },
    {
      field: "sec",
      headerName: "SEC",
      flex: 1,
      minWidth: 50,
      maxWidth: 80,
      editable: (params) => !params.data?.isAbandon,
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;

        // Only allow numeric values and empty string
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          const numericValue = parseInt(newValue, 10);

          if (newValue === "" || (numericValue >= 0 && numericValue < 60)) {
            params.data.sec =
              newValue === "" ? "" : String(numericValue).padStart(2, "0");
            params.data.errorSec = false;
            params.data.dn =
              params.data.dn && !timePenalties.includes(params.data.dn)
                ? ""
                : params.data.dn;

            // Auto-save logic
            params.data.oldSailNum = "";
            let data = makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            );
            saveRow(data, params.context);

            return true;
          }
        }

        params.data.errorSec = true;
        return false;
      },
      cellClassRules: {
        error: (params) => params.data.errorSec, // Apply 'error' class dynamically
      },
    },
    {
      field: "dn",
      headerName: "DN",
      suppressKeyboardEvent: (params) => {
        return ["ArrowDown", "ArrowUp", "Enter"].includes(params.event.key);
      },
      flex: 2,
      minWidth: 80,
      maxWidth: 180,
      editable: (params) => !params.data?.isAbandon,
      cellEditor: PenaltySelectEditor,
      cellEditorParams: { params: props.penalties },
      valueFormatter: (params) =>
        params.data?.isAbandon ? "ABN" : params.value,
      valueSetter: (params) => {
        const selectedValue = params.newValue;
        // console.log("the DN Data", params);
        params.data.dn = selectedValue;
        // Check if the selected value is part of the `timePenalties` array
        if (!timePenalties.includes(selectedValue) && params?.data?.dn != "") {
          // console.log("Selected Value:", selectedValue);
          // Update the `hr` field to "00" if selected value is part of timePenalties
          params.data.hr = "00";
          params.data.min = "00";
          params.data.sec = "00";
          params.data.errorHR = false;
          params.data.errorMin = false;
          params.data.errorSec = false;
        }
        if (
          selectedValue != "" &&
          (selectedValue === "DNC" || !timePenalties.includes(selectedValue))
        ) {
          params.data.finishDate = "";
        }
        let data = makePayloadForUpdate(
          params.data,
          params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
          params.data.min ? String(params.data.min).padStart(2, "0") : "00",
          params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
          params.context.sessionId,
        );
        saveRow(data, params.context);
        // Ensure the grid gets the correct value
        return true;
      },
    },
    {
      field: "finishDate",
      headerName: "Date",
      //sortable: true,
      hide: !props.overnight,
      flex: 2,
      minWidth: 150,
      maxWidth: 250,
      filter: "agDateColumnFilter", // Enables date filtering
      // editable: params => !params.data?.isAbandon, // Makes the column editable
      editable: (params) =>
        !params.data?.isAbandon &&
        !(
          params.data?.dn &&
          (params.data.dn === "DNC" || !timePenalties.includes(params.data.dn))
        ),

      cellEditor: "agDateCellEditor", // Uses the built-in AG Grid Date Picker
      // cellEditorParams: {
      //   params: { input: { type: "date" } },
      // },
      cellEditorParams: {
        useBrowserDatePicker: true,
      },

      // Display properly formatted date
      // valueFormatter: (params) => {
      //   if (!params.value) return "";
      //   return new Date(params.value).toLocaleDateString(systemLocale);
      // },

      valueFormatter: (params) => {
        if (!params.value) return "";

        if (
          params.data?.dn &&
          (params.data.dn === "DNC" || !timePenalties.includes(params.data.dn))
        ) {
          return "";
        }

        return new Date(params.value).toLocaleDateString(systemLocale);
      },

      // valueGetter: (params) => {
      //   // Show blank if DNC or no finishDate, otherwise show the stored value
      //   if (
      //     !params.data?.finishDate ||
      //     (params.data.dn != "" &&
      //       (params.data.dn === "DNC" ||
      //         !timePenalties.includes(params.data.dn)))
      //   )
      //     return "";
      //   return params.data.finishDate;
      // },
      valueGetter: (params) => {
        if (!params.data?.finishDate) return null;
        return new Date(params.data.finishDate);
      },

      // Handle update
      // valueSetter: (params) => {
      //   if (!params.newValue) return false;

      //   const date = new Date(params.newValue);
      //   const localDate = new Date(
      //     date.getTime() - date.getTimezoneOffset() * 60000
      //   );
      //   const formatted = localDate.toISOString().split("T")[0];

      //   // update real field
      //   params.data.finishDate = formatted;

      //   // custom update logic
      //   params.data.oldSailNum = "";
      //   const data = makePayloadForUpdate(
      //     params.data,
      //     params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
      //     params.data.min ? String(params.data.min).padStart(2, "0") : "00",
      //     params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
      //     params.context.sessionId
      //   );

      //   saveRow(data, params.context);

      //   return true;
      // },
      valueSetter: (params) => {
        if (
          params.data?.dn &&
          (params.data.dn === "DNC" || !timePenalties.includes(params.data.dn))
        ) {
          return false;
        }

        // Handle clearing the date
        if (!params.newValue || params.newValue === "") {
          params.data.finishDate = "";

          saveRow(
            makePayloadForUpdate(
              params.data,
              params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
              params.data.min ? String(params.data.min).padStart(2, "0") : "00",
              params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
              params.context.sessionId,
            ),
            params.context,
          );

          return true;
        }

        if (!(params.newValue instanceof Date)) return false;

        const localDate = new Date(
          params.newValue.getTime() -
            params.newValue.getTimezoneOffset() * 60000,
        );

        params.data.finishDate = localDate.toISOString().split("T")[0];

        saveRow(
          makePayloadForUpdate(
            params.data,
            params.data.hr ? String(params.data.hr).padStart(2, "0") : "00",
            params.data.min ? String(params.data.min).padStart(2, "0") : "00",
            params.data.sec ? String(params.data.sec).padStart(2, "0") : "00",
            params.context.sessionId,
          ),
          params.context,
        );

        return true;
      },
    },
    {
      field: "fleetName",
      headerName: "FLEET",
      flex: 2,
      minWidth: 80,
      maxWidth: 100,
      cellRenderer: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            }}
            title={params.value || ""}
          >
            {params.value}
          </span>
        </div>
      ),
    },
    {
      field: "del",
      headerName: "DROP",
      flex: 2,
      minWidth: 70,
      maxWidth: 170,
      cellRenderer: (params) => (
        <Button
          color="primary"
          className="ty_cross_btn"
          onClick={() =>
            handleCompletedDelClick(params.data.sailNum, params.data, params)
          }
          disabled={params.data?.isAbandon}
        >
          ×
        </Button>
      ),
    },
  ]);

  const toggleAlpha = () => {
    setSNWithAlpha((prev) => !prev);
    if (gridRefs[0].current) {
      if (gridRefs[0]?.current?.api) {
        gridRefs[0].current.api.refreshCells({ force: true });
      } else {
        console.error("Grid reference or API not available");
      }
    }
  };

  const isDefaultHrAllowed = (context) => {
    return !!(
      context.retainHR &&
      context.selectedHr &&
      (!context.retainDN ||
        !context.selectedDidNot ||
        timePenalties.includes(context.selectedDidNot))
    );
  };

  const handleBoxClick = (params) => {
    //  console.log("Box clicked!", params);
    //  console.log("Box clicked aboutFinishRaceEntrants", aboutFinishRaceEntrants);
    if (
      params.context.aboutFinishRaceEntrants.filter(
        (x) => x.sailNum.toLowerCase() === params.value.toLowerCase(),
      ).length > 0
    )
      return;
    unfinishedEntrants = params.context.unfinishedEntrants;
    aboutFinishRaceEntrants = params.context.aboutFinishRaceEntrants;
    completeFinishRaceEntrants = params.context.completeFinishRaceEntrants;

    //alert(`Clicked on row: ${params.data.id}, value: ${params.value}`);
    let unFinishRow = unfinishedEntrants.filter(
      (x) => x.sailNum.toLowerCase() == params.value.toLowerCase(),
    );
    if (unFinishRow.length > 0) {
      let unfinishedEntrants2 = unfinishedEntrants.filter(
        (x) => x.sailNum.toLowerCase() !== params.value.toLowerCase(),
      );

      let defaultHr = isDefaultHrAllowed(params.context)
        ? params.context.selectedHr
        : "00";
      let defaultDn =
        params.context.retainDN && params.context.selectedDidNot
          ? params.context.selectedDidNot
          : "";

      unFinishRow[0].hr = defaultHr;
      unFinishRow[0].min = "00";
      unFinishRow[0].sec = "00";
      unFinishRow[0].dn = defaultDn;
      unFinishRow[0].place = "";
      unFinishRow[0].position = "";

      let hasBlankSailNum = aboutFinishRaceEntrants.some(
        (entrant) => !entrant.sailNum || entrant.sailNum.trim() === "",
      );
      let aboutFinishRaceEntrants2 = [];
      if (aboutFinishRaceEntrants.length >= 1 && hasBlankSailNum) {
        let firstBlankFound = false;

        let updatedEntrants = aboutFinishRaceEntrants.map((entrant) => {
          if (
            !firstBlankFound &&
            (!entrant.sailNum || entrant.sailNum.trim() === "")
          ) {
            firstBlankFound = true; // Mark that the first blank has been updated

            return {
              ...unFinishRow[0],
              hr: entrant.hr,
              min: entrant.min,
              sec: entrant.sec,
              dn: entrant.dn,
            };
          }
          return entrant; // Keep others unchanged
        });

        aboutFinishRaceEntrants2 = [...updatedEntrants];
      } else {
        aboutFinishRaceEntrants.push(unFinishRow[0]);
        aboutFinishRaceEntrants2 = [...aboutFinishRaceEntrants];
      }
      //aboutFinishRaceEntrants2.push([]);
      //  console.log("aboutFinishRaceEntrants", aboutFinishRaceEntrants);
      unfinishedEntrants = [...unfinishedEntrants2];
      dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants));

      aboutFinishRaceEntrants = [...aboutFinishRaceEntrants2];
      dispatch(actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants2));
    }

    setTimeout(() => {
      if (gridRefs[1].current && gridRefs[1].current.api) {
        const rowIndex = aboutFinishRaceEntrants.length - 1; // Last row index
        gridRefs[1].current.api.ensureIndexVisible(rowIndex);

        gridRefs[1].current.api.setFocusedCell(rowIndex, "sailNum"); // Focus on the "sailNum" column
        gridRefs[1].current.api.startEditingCell({
          rowIndex:
            aboutFinishRaceEntrants.length > 0
              ? aboutFinishRaceEntrants.length - 1
              : 0, // Index of new row
          colKey: "sailNum", // Column to focus on
        });
      }
    }, 100);

    //  savePrefinished();
  };

  const handleDelClick = (cellvalue, celldata, gridParams) => {
    unfinishedEntrants = gridParams.context.unfinishedEntrants;
    aboutFinishRaceEntrants = gridParams.context.aboutFinishRaceEntrants;
    completeFinishRaceEntrants = gridParams.context.completeFinishRaceEntrants;

    if (gridParams.context) {
      unfinishedEntrants = gridParams.context.unfinishedEntrants;
      aboutFinishRaceEntrants = gridParams.context.aboutFinishRaceEntrants;
    }
    let aboutFinishRow = aboutFinishRaceEntrants.filter(
      (x) => x.id == celldata.id,
    );
    if (aboutFinishRow.length > 0) {
      let aboutFinishRaceEntrants2 = aboutFinishRaceEntrants.filter(
        (x) => x.id != celldata.id,
      );

      if (aboutFinishRow[0].boatName) {
        let unfinishedEntrants2 = [...unfinishedEntrants];
        aboutFinishRow[0].hr = "00";
        aboutFinishRow[0].min = "00";
        aboutFinishRow[0].sec = "00";
        aboutFinishRow[0].dn = "";
        aboutFinishRow[0].position = "";
        aboutFinishRow[0].place = "";
        aboutFinishRow[0].editable = false;
        aboutFinishRow[0].errorHR = false;
        aboutFinishRow[0].errorMin = false;
        aboutFinishRow[0].errorSec = false;
        unfinishedEntrants2.push(aboutFinishRow[0]);

        unfinishedEntrants = unfinishedEntrants2;
        dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants2));
      }

      aboutFinishRaceEntrants = [...aboutFinishRaceEntrants2];
      dispatch(actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants));
    }
  };

  const handleCompletedDelClick = async (cellvalue, celldata, params) => {
    // console.log("Now  unfinishedEntrants clicked!", celldata);
    // console.log("Time ..................." + formatTime());

    unfinishedEntrants = params.context.unfinishedEntrants;
    aboutFinishRaceEntrants = params.context.aboutFinishRaceEntrants;
    completeFinishRaceEntrants = params.context.completeFinishRaceEntrants;
    setSortField("position");
    setIsSortAsc(false);
    //alert(`Clicked on row:, value: ${cellvalue}`);
    // setPayload(makePayloadForUpdate(celldata));
    // console.log("the payload", payload);
    //  setFinishTimePayload([payload]);

    let unFinishRow = completeFinishRaceEntrants?.filter(
      (x) => x?.id == celldata?.id,
    ); //completeFinishRaceEntrants
    if (unFinishRow?.length > 0) {
      let completeFinishRaceEntrants2 = completeFinishRaceEntrants?.filter(
        (x) => x?.sailNum?.toLowerCase() !== celldata?.sailNum?.toLowerCase(),
      ); //completeFinishRaceEntrants2
      let unfinishedEntrants2 = [...unfinishedEntrants];
      if (unFinishRow[0].boatName) {
        unFinishRow[0].hr = "00";
        unFinishRow[0].min = "00";
        unFinishRow[0].sec = "00";
        unFinishRow[0].position = "";
        unFinishRow[0].place = "";
        unFinishRow[0].editable = false;
        unFinishRow[0].errorHR = false;
        unFinishRow[0].errorMin = false;
        unFinishRow[0].errorSec = false;
        unFinishRow[0].dn = "";
        unfinishedEntrants2.push(unFinishRow[0]);
        unfinishedEntrants = [...unfinishedEntrants2];
        dispatch(actions.updateInitialFinishRaceEntrants(unfinishedEntrants));
      }

      completeFinishRaceEntrants2.sort((a, b) => b.position - a.position);
      let updated = completeFinishRaceEntrants2.map((entrant, index) => ({
        ...entrant,
        position: completeFinishRaceEntrants2.length - index,
      }));

      completeFinishRaceEntrants = [...updated]; //completeFinishRaceEntrants2

      dispatch(
        actions.updateCompleteFinishRaceEntrants(completeFinishRaceEntrants),
      );
    }
    let finishedData = makePayloadForUpdate(
      celldata,
      celldata.hr,
      celldata.min,
      celldata.sec,
      params.context.sessionId,
    );
    deleteRow(finishedData);
  };

  const makePayloadForUpdate = (obj, hrValue, minValue, secValue, id) => {
    // console.log("THE OBJ", obj);

    let targetObj = {};
    const isCapturedNow = obj.editable;
    targetObj["raceSessionId"] = id;
    targetObj["sessionEntrantId"] = isCapturedNow ? "" : obj.sessionEntrantId;
    // console.log("THE isCapturedNow", isCapturedNow);
    if (obj.status !== undefined) {
      targetObj["sessionEntrantId"] = obj.sessionEntrantId
        ? obj.sessionEntrantId
        : "";
    } else {
      targetObj["sessionEntrantId"] = isCapturedNow ? "" : obj.id;
    }

    targetObj["place"] = obj.place;
    targetObj["sailNum"] = obj.sailNum;

    // Ensure hr, min, sec are properly fetched and formatted
    targetObj["hr"] = hrValue;
    targetObj["mm"] = minValue;
    targetObj["ss"] = secValue;

    targetObj["date"] = props.raceSessionsDate;
    targetObj["finishDate"] = obj.finishDate;
    targetObj["dn"] = obj.dn;
    targetObj["fleet"] = obj.fleetName;
    targetObj["oldSailNum"] = obj.oldSailNum ? obj.oldSailNum : null;
    if (props?.caseOTBEntrant) {
      targetObj["class"] = obj?.class ? obj?.class : "";
    }
    // console.log("the oldSailNum",obj.oldSailNum)

    // console.log("Final Payload:", targetObj);
    return targetObj;
  };

  const handleNowAboutClick = (cellvalue, celldata, params) => {
    if (
      params.context.isPlace &&
      celldata.dn === "" &&
      (!celldata.place || celldata.place === 0 || isNaN(celldata.place))
    ) {
      props.activateSnackbarTab(
        "Please define either place or DN.",
        "error",
        true,
      );
      return;
    }
    if (
      cellvalue &&
      (completeFinishRaceEntrants.some(
        (x) => x.sailNum.toLowerCase() === cellvalue.toLowerCase(),
      ) ||
        aboutFinishRaceEntrants.filter(
          (x) =>
            x.sailNum?.trim().toLowerCase() === cellvalue.trim().toLowerCase(),
        ).length >= 2)
    ) {
      props.activateSnackbarTab(
        `Sail Number ${cellvalue} already added!`,
        "error",
        true,
      );
      const currentRowIndex = aboutFinishRaceEntrants.findIndex(
        (x) => x.id === celldata.id,
      );
      setTimeout(() => {
        if (gridRefs[1].current && gridRefs[1].current.api) {
          // Ensure the correct row is visible
          gridRefs[1].current.api.ensureIndexVisible(currentRowIndex);

          // Focus on the correct row and column
          gridRefs[1].current.api.setFocusedCell(currentRowIndex, "sailNum");

          gridRefs[1].current.api.startEditingCell({
            rowIndex: currentRowIndex, // Use the correct row index
            colKey: "sailNum",
          });
        }
      }, 100);

      return;
    }
    console.log("THE PRMS", params.context.isPlace);
    if (!cellvalue && !params.context.isPlace) {
      // Get the correct row index
      const currentRowIndex = aboutFinishRaceEntrants.findIndex(
        (x) => x.id === celldata.id,
      );
      setTimeout(() => {
        props.activateSnackbarTab("Please define sail number", "error", true);
      }, 300);
      setTimeout(() => {
        if (gridRefs[1].current && gridRefs[1].current.api) {
          const rowIndex = currentRowIndex; // Last row index
          gridRefs[1].current.api.ensureIndexVisible(rowIndex);

          gridRefs[1].current.api.setFocusedCell(rowIndex, "sailNum"); // Focus on the "sailNum" column
          gridRefs[1].current.api.startEditingCell({
            rowIndex:
              aboutFinishRaceEntrants.length > 0
                ? aboutFinishRaceEntrants.length - 1
                : 0, // Index of new row
            colKey: "sailNum", // Column to focus on
          });
        }
      }, 100);
      return;
    }

    unfinishedEntrants = params.context.unfinishedEntrants;
    let aboutFinishRaceEntrants3 = params.context.aboutFinishRaceEntrants;
    completeFinishRaceEntrants = params.context.completeFinishRaceEntrants;
    // setPayload(makePayloadForUpdate(celldata));
    let aboutFinishRow;
    if (celldata.sailNum == "") {
      aboutFinishRow = [celldata];
    } else {
      aboutFinishRow = aboutFinishRaceEntrants3.filter(
        (x) => x?.sailNum?.toUpperCase() == cellvalue?.toUpperCase(),
      );
    }
    console.log("aboutFinishRaceEntrants3", aboutFinishRaceEntrants3);
    console.log("aboutFinishRow ...................", aboutFinishRow);
    //alert(`Clicked on row:, value: ${cellvalue}`);
    //debugger
    if (aboutFinishRow.length > 0) {
      let aboutFinishRaceEntrants2;

      aboutFinishRaceEntrants2 = aboutFinishRaceEntrants3?.filter(
        (x) =>
          x.id !== celldata.id &&
          x.sailNum?.toLowerCase() !== celldata.sailNum?.toLowerCase(),
      );

      let completeFinishRaceEntrants2 = [...completeFinishRaceEntrants];
      if (aboutFinishRow[0].boatName == "") {
        let matchedUnfinished = params.context.snWithAlpha
          ? unfinishedEntrants.find(
              (x) =>
                x.sailNum?.toLowerCase() ===
                aboutFinishRow[0].sailNum?.toLowerCase(),
            )
          : unfinishedEntrants.find(
              (x) =>
                x.sailNum?.toLowerCase().replace(/[A-Za-z]/g, "") ===
                aboutFinishRow[0].sailNum?.toLowerCase(),
            );

        aboutFinishRow[0] = { ...aboutFinishRow[0], ...matchedUnfinished };
      }

      aboutFinishRow[0].hr = celldata.hr.toString().padStart(2, "0");
      aboutFinishRow[0].min = celldata.min.toString().padStart(2, "0");
      aboutFinishRow[0].sec = celldata.sec.toString().padStart(2, "0");
      aboutFinishRow[0].position = completeFinishRaceEntrants.length + 1;
      aboutFinishRow[0].finishDate = props.overnight
        ? new Date().toISOString().split("T")[0]
        : "";

      if (celldata.fleetName === "" && aboutFinishRow[0].fleetName === "")
        aboutFinishRow[0].sailNum = celldata.sailNum.toUpperCase();

      if (props.place === false)
        aboutFinishRow[0].place = completeFinishRaceEntrants.length + 1;
      else
        aboutFinishRow[0].place =
          aboutFinishRow[0].place !== ""
            ? parseInt(aboutFinishRow[0].place, 10)
            : "";

      console.log("aboutFinishRow to be added", aboutFinishRow[0]);
      completeFinishRaceEntrants2.unshift(aboutFinishRow[0]);

      completeFinishRaceEntrants = completeFinishRaceEntrants2;

      aboutFinishRaceEntrants3 = [...aboutFinishRaceEntrants2];
      dispatch(actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants3));
      dispatch(
        actions.updateCompleteFinishRaceEntrants(completeFinishRaceEntrants),
      );
      if (cellvalue) {
        let finishedData = makePayloadForUpdate(
          aboutFinishRow[0],
          aboutFinishRow[0].hr,
          aboutFinishRow[0].min,
          aboutFinishRow[0].sec,
          params.context.sessionId,
        );
        saveRow(finishedData);
      }
    }
  };

  const addRow = () => {
    // Dynamically count empty rows each time
    const emptyRowCount = aboutFinishRaceEntrants.filter(
      (row) => !row.sailNum || !row.boatName,
    ).length;

    if (emptyRowCount >= 6) return; // Prevent adding more than 6 empty rows

    const combinedArray = [
      ...unfinishedEntrants,
      ...aboutFinishRaceEntrants,
      ...completeFinishRaceEntrants,
    ];
    const maxId = combinedArray.reduce(
      (max, item) => (item.id > max ? item.id : max),
      0,
    );

    let defaultHr =
      retainHr &&
      selectedHr &&
      (!retainDidNot ||
        !selectedDidNot ||
        timePenalties.includes(selectedDidNot))
        ? selectedHr
        : "00";
    let defaultDn = retainDidNot && selectedDidNot ? selectedDidNot : "";

    let aboutFinishRaceEntrants2 = aboutFinishRaceEntrants;
    aboutFinishRaceEntrants2.push({
      id: maxId + 1,
      hr: defaultHr,
      min: "00",
      sec: "00",
      dn: defaultDn,
      fleetName: "",
      boatName: "",
      sailNum: "",
      editable: true,
      place: "",
      position: "",
    });
    console.log("the single", aboutFinishRaceEntrants2[0]);
    console.log("the single un", unfinishedEntrants[0]);
    console.log("aboutFinishRaceEntrants added", aboutFinishRaceEntrants);
    aboutFinishRaceEntrants = [...aboutFinishRaceEntrants2];
    dispatch(actions.updateAboutFinishRaceEntrants(aboutFinishRaceEntrants));
    if (props.place) {
      setTimeout(() => {
        if (gridRefs[1].current && gridRefs[1].current.api) {
          // console.log("THE REF", gridRefs[1]);

          gridRefs[1].current.api.startEditingCell({
            rowIndex:
              aboutFinishRaceEntrants.length > 0
                ? aboutFinishRaceEntrants.length - 1
                : 0, // Index of new row
            colKey: "place", // Column to focus on
          });
        }
      }, 100);
    } else {
      setTimeout(() => {
        if (gridRefs[1].current && gridRefs[1].current.api) {
          // console.log("THE REF", gridRefs[1]);

          gridRefs[1].current.api.startEditingCell({
            rowIndex:
              aboutFinishRaceEntrants.length > 0
                ? aboutFinishRaceEntrants.length - 1
                : 0, // Index of new row
            colKey: "sailNum", // Column to focus on
          });
        }
      }, 100);
    }
  };

  function download_csv() {
    console.log("SSS", completeFinishRaceEntrants);
    if (completeFinishRaceEntrants.length === 0) {
      props.activateSnackbarTab(
        "No data in Finished Table to export.",
        "error",
        true,
      );
      return;
    } else {
      let filteredItems = props.place
        ? completeFinishRaceEntrants.map(
            ({ boatName, sailNum, fleetName, place, dn }) => ({
              boatName,
              sailNum,
              fleetName,
              place,
              dn,
            }),
          )
        : completeFinishRaceEntrants.map(
            ({ boatName, sailNum, fleetName, hr, min, sec, dn }) => ({
              boatName,
              sailNum,
              fleetName,
              hr,
              min,
              sec,
              dn,
            }),
          );

      let csvHeader =
        Object.keys(filteredItems[0])
          .map((key) => {
            let header = key.charAt(0).toUpperCase() + key.slice(1);

            if (props.caseOTBEntrant && key === "boatName") {
              header = "Class"; // override if caseOTBEntrant is true
            } else {
              header = header
                .replace("Name", "")
                .replace("SailNum", "Sail No")
                .replace("Hr", "HR")
                .replace("Min", "MN")
                .replace("Sec", "SC")
                .replace("Dn", "DidNot");
            }

            return header;
          })
          .join(",") + "\n";

      console.log("csvHeader", csvHeader);
      let csvBody = filteredItems
        .map((row) => Object.values(row).join(","))
        .join("\n");
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + "/" + time;

      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvHeader + csvBody);
      hiddenElement.target = "_blank";
      hiddenElement.download = dateTime + "-ManualTimes.csv";
      hiddenElement.click();
    }
  }

  const getRowStyle = () => ({
    marginBottom: "6px",
    // borderBottom: "6px solid #f1f7f9",
  });

  const applyFinishedSearch = (value) => {
    if (gridRefs[2]?.current?.api) {
      gridRefs[2].current.api.setFilterModel({
        sailNum: {
          type: "contains",
          filter: value,
        },
      });
    }
  };

  const applyUnfinishedSearch = (value) => {
    setUnfinishedSearchValue(value); //store search input in state
    if (gridRefs[0]?.current) {
      gridRefs[0].current.onFilterChanged(); // Trigger external filtering
    }
  };

  const isUnfinishedExternalFilter = () => {
    return unfinishedSearchValue.trim() !== ""; // Activate filtering when search is not empty
  };

  const doesUnfinishedFilterPass = (node) => {
    if (!unfinishedSearchValue.trim()) return true; // Show all rows when search is empty
    const sailNumMatch = node.data?.sailNum
      ?.toLowerCase()
      .includes(unfinishedSearchValue.toLowerCase());
    const boatNameMatch = node.data?.boatName
      ?.toLowerCase()
      .includes(unfinishedSearchValue.toLowerCase());
    return sailNumMatch || boatNameMatch; // Row is visible if either sailNum OR boatName matches
  };

  const rowHeight = 55;
  const headerHeight = 150;
  const minHeight = 250;
  const maxHeight = 280;

  const rowCount = aboutFinishRaceEntrants.length;
  const totalHeight = headerHeight + rowCount * rowHeight;
  const gridHeight = Math.min(Math.max(totalHeight, minHeight), maxHeight);

  const focusNextEditableCell = (api, allColumns, rowIndex) => {
    const nextRowIndex = Math.min(rowIndex, api.getDisplayedRowCount() - 1);
    const nextData = api.getDisplayedRowAtIndex(nextRowIndex)?.data;
    const col = allColumns.find((c) =>
      typeof c.editable === "function"
        ? c.editable({ data: nextData })
        : c.editable,
    );
    if (col) {
      api.setFocusedCell(nextRowIndex, col.field);
      api.startEditingCell({ rowIndex: nextRowIndex, colKey: col.field });
    }
  };

  const handleCellKeyDown = (event) => {
    const key = event.event.key;
    const api = event.api;
    const rowIndex = event.rowIndex;
    const rowData = api.getDisplayedRowAtIndex(rowIndex)?.data;
    const sailNum = rowData?.sailNum;
    const context = event.context;
    const allColumns = api.getColumnDefs().filter((col) => !!col.field);

    const getNextEditableCol = (startIndex) => {
      let index = startIndex;
      while (
        index < allColumns.length &&
        (["boatName", "fleetName"].includes(allColumns[index]?.field) ||
          allColumns[index]?.hide)
      ) {
        index++;
      }
      return allColumns[index];
    };

    const stopAndFocus = (nextRowIndex, nextCol) => {
      const nextData = api.getDisplayedRowAtIndex(nextRowIndex)?.data;
      api.setFocusedCell(nextRowIndex, nextCol.field);

      const isEditable =
        typeof nextCol.editable === "function"
          ? nextCol.editable({ data: nextData })
          : nextCol.editable;

      if (isEditable) {
        // Use a short delay to allow focus to settle before starting edit mode
        setTimeout(() => {
          api.startEditingCell({
            rowIndex: nextRowIndex,
            colKey: nextCol.field,
          });
        }, 100);
      }
    };

    switch (key) {
      case "Tab": {
        event.event.preventDefault();
        api.stopEditing();

        const currentIndex = allColumns.findIndex(
          (c) => c.field === event.column.getColId(),
        );
        let nextColIndex = currentIndex + 1;
        let nextCol = getNextEditableCol(nextColIndex);
        let nextRowIndex = rowIndex;

        if (!nextCol) {
          // go to next row's first editable cell
          nextRowIndex++;
          nextCol = getNextEditableCol(0);
        }

        if (nextCol) stopAndFocus(nextRowIndex, nextCol);
        break;
      }

      case "Enter": {
        event.event.preventDefault();
        api.stopEditing();
        console.log("THE ENTER", event);
        if (event.context.gridName === "finished") {
          if (event.column.getColId() === "del") {
            handleCompletedDelClick(sailNum, rowData, {
              value: sailNum,
              data: rowData,
              context,
            }).then(() =>
              setTimeout(
                () => focusNextEditableCell(api, allColumns, rowIndex),
                0,
              ),
            );
          }
        } else {
          if (event.column.getColId() === "remove") {
            handleDelClick(sailNum, rowData, {
              value: sailNum,
              data: rowData,
              context,
            });
            setTimeout(
              () => focusNextEditableCell(api, allColumns, rowIndex),
              0,
            );
          } else if (event.column.getColId() === "sailNum") {
            event.event.preventDefault();
            api.stopEditing();

            const currentIndex = allColumns.findIndex(
              (c) => c.field === event.column.getColId(),
            );
            let nextColIndex = currentIndex + 1;
            let nextCol = getNextEditableCol(nextColIndex);
            let nextRowIndex = rowIndex;

            if (!nextCol) {
              // go to next row's first editable cell
              nextRowIndex++;
              nextCol = getNextEditableCol(0);
            }

            if (nextCol) stopAndFocus(nextRowIndex, nextCol);
            break;
          } else {
            handleNowAboutClick(sailNum, rowData, {
              value: sailNum,
              data: rowData,
              context,
            });
            setTimeout(
              () => focusNextEditableCell(api, allColumns, rowIndex),
              100,
            );
          }
        }
        break;
      }

      case "Delete": {
        event.event.preventDefault();
        api.stopEditing();
        if (event.context.gridName === "finished") {
          handleCompletedDelClick(sailNum, rowData, {
            value: sailNum,
            data: rowData,
            context,
          }).then(() =>
            setTimeout(
              () => focusNextEditableCell(api, allColumns, rowIndex),
              0,
            ),
          );
        } else {
          handleDelClick(sailNum, rowData, {
            value: sailNum,
            data: rowData,
            context,
          });
          setTimeout(() => focusNextEditableCell(api, allColumns, rowIndex), 0);
        }
        break;
      }

      default:
        break;
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: {
                lg: 0,
                md: "8px",
                sm: "8px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 6,
                alignItems: "center",
                flexDirection: "row",
                pb: 0,
              }}
            >
              <Box>
                <FormLabel className="ty-uppercase-label">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    ON WATER ENTRANTS
                  </Box>
                </FormLabel>
                <Tooltip
                  title={
                    "Turn on this switch to filter only those boats that have been marked 'on water' on TES."
                  }
                  placement="top"
                >
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        //disabled={props.isOnWaterDisabled}
                        name={"ON_WATER_ENTRANTS"}
                        checked={onWaterEntrants}
                        onChange={handleOnWaterSwitchChange}
                      />
                    }
                    label={onWaterEntrants ? "Yes" : "No"}
                    labelPlacement="end"
                    sx={{ paddingLeft: "5px", gap: "10px" }}
                  />
                </Tooltip>
              </Box>
              <Box>
                <FormLabel className="ty-uppercase-label">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    SN WITH ALPHA
                  </Box>
                </FormLabel>

                <FormControlLabel
                  control={
                    <IOSSwitch
                      name="SN_WITH_ALPHA"
                      checked={snWithAlpha}
                      onChange={toggleAlpha}
                    />
                  }
                  label={snWithAlpha ? "Yes" : "No"}
                  labelPlacement="end"
                  sx={{ paddingLeft: "5px", gap: "10px" }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                justifyContent: "end",
                marginTop: { md: "8px", sm: "8px", xs: "8px" },
                flexWrap: {
                  xl: "nowrap",
                  lg: "nowrap",
                  md: "nowrap",
                  sm: "nowrap",
                  xs: "wrap",
                },
                width: {
                  lg: "auto",
                  md: "100%",
                  sm: "100%",
                },
              }}
            >
              <Button
                className="ty_secondary_btn"
                sx={{ textAlign: "center" }}
                component={Link}
                to={raceSessionURL}
              >
                Return To Race Session
              </Button>
              <Button
                className="ty_secondary_btn"
                onClick={() => handleProcessResultsClick()}
                disabled={props.numEntrants <= 0}
              >
                Process Results
              </Button>

              <Button
                className="ty_secondary_btn"
                onClick={download_csv}
                disabled={props.numEntrants <= 0}
              >
                Export
              </Button>
            </Box>
          </Box>
        </Grid>
        {/* Finish Time Entry Section */}
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={6} sm={12} sx={{ paddingTop: "0 !important" }}>
              <Box>
                <Typography
                  variant="h6"
                  gutterBottom
                  className="ty_form_heading "
                  sx={{
                    marginBottom: 2,
                  }}
                >
                  ABOUT TO FINISH
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    pb: 2,
                  }}
                >
                  {props.place === false && (
                    <Box>
                      <FormLabel className="ty-uppercase-label">
                        RETAIN HR{" "}
                        {retainHr && selectedHr ? `(${selectedHr})` : ""}
                      </FormLabel>

                      <FormControlLabel
                        control={
                          <IOSSwitch
                            disabled={false}
                            name={"RETAIN_HR"}
                            checked={retainHr}
                            onChange={updateHr}
                          />
                        }
                        label={retainHr ? "Yes" : "No"}
                        labelPlacement="end"
                        sx={{ paddingLeft: "5px", gap: "10px" }}
                      />
                    </Box>
                  )}
                  <Box>
                    <FormLabel className="ty-uppercase-label">
                      RETAIN DID NOT{" "}
                      {retainDidNot && selectedDidNot
                        ? `(${selectedDidNot})`
                        : ""}
                    </FormLabel>

                    <FormControlLabel
                      control={
                        <IOSSwitch
                          disabled={false}
                          name="RETAIN_DID_NOT"
                          checked={retainDidNot}
                          onChange={updateDidNot}
                        />
                      }
                      label={retainDidNot ? "Yes" : "No"}
                      labelPlacement="end"
                      sx={{ pl: 1, gap: "10px" }}
                    />
                  </Box>
                  <Button
                    className="ty_secondary_btn"
                    sx={{
                      marginTop: { xs: "0.5rem", md: "0.5rem" },
                    }}
                    onClick={preloadAll}
                    disabled={unfinishedEntrants.length === 0}
                  >
                    PRELOAD ALL
                  </Button>
                </Box>
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: gridHeight,
                    overflow: "auto",
                    overflowX: "auto",
                  }}
                >
                  <AgGridReact
                    domLayout="normal" // Automatically adjusts grid height based on content
                    ref={gridRefs[1]}
                    suppressKeyboardEvent={({ event, editing }) => {
                      return editing && event.key === "Enter";
                    }}
                    context={{ ...gridContext, gridName: "aboutToFinish" }}
                    className="ty_inlineEdit_datagrid ty-grid-cusom-fixes ty_about_to_finish ty_grid_focus"
                    columnDefs={
                      props.place
                        ? aboutToFinishPlaceColumnDefs
                        : aboutToFinishColumnDefs
                    }
                    headerHeight={36}
                    rowHeight={36}
                    rowData={aboutFinishRaceEntrants}
                    stopEditingWhenCellsLoseFocus={true}
                    defaultColDef={{
                      // sortable: false,
                      filter: false,
                      resizable: false,
                      flex: 1,
                      minWidth: 100,
                      suppressMovable: true,
                    }}
                    //onSortChanged={handleSortChanged}
                    suppressScrollOnNewData={true}
                    onCellKeyDown={handleCellKeyDown}
                    getRowStyle={getRowStyle}
                    onGridReady={(params) => {
                      params.api.sizeColumnsToFit();
                      setGridApi(params.api);
                    }}
                    gridOptions={{ enableBrowserTooltips: true }}
                    overlayNoRowsTemplate={"No About to finish entrants."}
                  />
                </div>
              </Box>
              <Divider
                sx={{
                  borderColor: "#DBDBDB",
                  marginTop: "16px",
                  marginBottom: "12px",
                }}
              />
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    // mb: 2,
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    className="ty_form_heading mt-0 mb-0"
                  >
                    FINISHED
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                    flexWrap: "wrap",
                    // gap: 2, // adds spacing between items
                  }}
                >
                  <Typography variant="p">
                    Number of boats accounted for:{" "}
                    <span style={{ color: "#356DAD", fontWeight: "600" }}>
                      {completeFinishRaceEntrants.length}
                    </span>
                  </Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <FormControl
                      size="small"
                      sx={{ maxWidth: 150, minWidth: 100 }}
                    >
                      {" "}
                      {/* fixed width */}
                      <Select
                        startAdornment={
                          <IconButton
                            size="small"
                            onClick={() => setIsSortAsc((prev) => !prev)} // toggle asc/desc
                          >
                            {isSortAsc ? (
                              <ArrowUpwardIcon fontSize="small" />
                            ) : (
                              <ArrowDownwardIcon fontSize="small" />
                            )}
                          </IconButton>
                        }
                        size={"small"}
                        value={sortField}
                        onChange={(e) => setSortField(e.target.value)}
                      >
                        {[
                          ...sortOptions,
                          ...(props.place
                            ? [{ label: "Place", value: "place" }]
                            : [{ label: "Time", value: "time" }]),
                        ].map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      sx={{ maxWidth: 100, minWidth: 100 }}
                      type="search"
                      size="small"
                      variant="outlined"
                      className="table_search_field"
                      placeholder="Sail No."
                      onChange={(e) => {
                        applyFinishedSearch(e.target.value);
                      }}
                    />
                  </Box>
                </Box>

                <div
                  className="ag-theme-alpine"
                  style={{ height: 500, overflow: "auto" }}
                >
                  <AgGridReact
                    key={`finish-grid-${props.place}`}
                    domLayout="normal" // Automatically adjusts grid height based on content
                    ref={gridRefs[2]}
                    context={{ ...gridContext, gridName: "finished" }}
                    className="ty_inlineEdit_datagrid ty_finished_grid ty_grid_focus"
                    columnDefs={
                      props.place ? finishedPlaceColumnDefs : finishedColumnDefs
                    }
                    rowData={completeFinishRaceEntrants}
                    getRowClass={getRowClass} // Apply row-level styling
                    getRowStyle={getRowStyle}
                    headerHeight={36}
                    rowHeight={36}
                    stopEditingWhenCellsLoseFocus={true}
                    onCellKeyDown={handleCellKeyDown}
                    suppressScrollOnNewData={true}
                    //onSortChanged={handleSortChanged}
                    defaultColDef={{
                      // sortable: false,
                      singleClickEdit: true,
                      filter: false,
                      resizable: false,
                      flex: 1,
                      minWidth: 100,
                      suppressMovable: true,
                      sortable: false,
                    }}
                    onFilterChanged={() => {
                      if (
                        gridRefs[2]?.current?.api.getDisplayedRowCount() === 0
                      ) {
                        gridRefs[2]?.current?.api.showNoRowsOverlay();
                      } else {
                        gridRefs[2]?.current?.api.hideOverlay();
                      }
                    }}
                    onGridReady={(params) => {
                      params.api.sizeColumnsToFit();
                      const style = document.createElement("style");
                      style.innerHTML = `
                            .ty_inlineEdit_datagrid .ag-header-cell-filter-button {
                              display: none !important;
                            }
                          `;
                      document.head.appendChild(style);
                    }}
                  />
                </div>
              </Box>
            </Grid>

            {/* Unfinished Section */}
            <Grid
              sx={{
                width: { md: "100%", sm: "100%", xs: "100%" },
                paddingTop: "0 !important",
              }}
              item
              lg={6}
              sm={12}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 0.5,
                    marginTop: { md: 1, sm: 1, xs: 1 },
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography variant="h6" className="ty_form_heading mb-0">
                    UN FINISHED
                  </Typography>
                  <TextField
                    type="search"
                    size="small"
                    variant="outlined"
                    className="table_search_field"
                    placeholder="Search Sail Number or Boat Name"
                    onChange={(e) => applyUnfinishedSearch(e.target.value)}
                  />
                </Box>
                <div
                  className="ag-theme-alpine"
                  style={{
                    minHeight: 100,
                    // height: 700, // Fixed height 500px
                    maxHeight: 1500,
                    width: "100%",
                    height: 1000,
                    overflow: "auto", // Enable scrolling
                  }}
                >
                  <AgGridReact
                    domLayout="normal" // Automatically adjusts grid height based on content
                    ref={gridRefs[0]}
                    context={gridContext}
                    className="ty_inlineEdit_datagrid"
                    columnDefs={unfinishedColumnDefs}
                    rowData={filteredUnfinishedEntrants}
                    headerHeight={36}
                    rowHeight={36}
                    //onSortChanged={handleSortChanged}
                    defaultColDef={{
                      //sortable: false,
                      draggable: false,
                      filter: true,
                      resizable: false,
                      flex: 1,
                      minWidth: 100,
                      suppressMovable: true,
                    }}
                    isExternalFilterPresent={isUnfinishedExternalFilter} //Register external filter
                    doesExternalFilterPass={doesUnfinishedFilterPass} //Apply custom filter logic
                    suppressScrollOnNewData={true}
                    onGridReady={(params) => {
                      gridRefs[0].current = params.api;
                      params.api.sizeColumnsToFit();
                    }}
                    gridOptions={{ enableBrowserTooltips: true }}
                    getRowStyle={getRowStyle}
                    noRowsOverlayComponentFramework={() => (
                      <div
                        style={{
                          padding: "10px",
                          textAlign: "center",
                          fontSize: "12px",
                          color: "gray",
                        }}
                      >
                        No Data Available
                      </div>
                    )}
                  />
                </div>
              </Box>
              <Box>
                <Typography variant="p">
                  Total Number of boats:{" "}
                  <span style={{ color: "#356DAD", fontWeight: "600" }}>
                    {filteredUnfinishedEntrants.length}
                  </span>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <StartTimeConfirmModal
        open={showStartTimeModal}
        onClose={handleStartTimeModalClose}
        onProceed={handleProceed}
        onUpdateStartTime={handleUpdateStartTime}
        fleetDetails={props.savedFleetDetails}
      />
    </>
  );
}